import useGetCompanyById from './useGetCompanyById';

export default function useGetIsVIPPurchaseEnabled(): boolean {
  const { company } = useGetCompanyById();

  return Boolean(company?.isVIPPurchaseEnabled);
}
